module.exports = require("react-native/Libraries/Utilities/LoadingView");
